import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';
import './Card.css';

export type CardVariant = 'default' | 'glass' | 'violet';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  hoverable?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { variant = 'default', hoverable = true, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'itb-card',
        `itb-card--${variant}`,
        hoverable && 'itb-card--hoverable',
        className,
      )}
      {...rest}
    >
      {/* Aquí iba `.itb-card__glow`, un resplandor blanco en radial-gradient
          sobre la esquina derecha. Se retiró con el resto de degradados
          decorativos (26-ago) y con él el `<div>`: una capa que no pinta
          nada sigue costando un nodo en cada card. */}
      <div className="itb-card__content">{children}</div>
    </div>
  );
});
